import axios from './axios'

export const timeline = function(){
	return axios
		.post('/alert/timeline')
		.then(res => res.data)
}
